import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { SnackbarService } from './snackbar.service';

@Component({
  selector: 'atlas-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss']
})
export class SnackbarComponent {
  public visible$: Observable<boolean>;
  public text$: Observable<string>;
  public actionText$: Observable<string>;

  constructor(private snackbarService: SnackbarService) {
    this.visible$ = this.snackbarService.visible$;
    this.text$ = this.snackbarService.text$;
    this.actionText$ = this.snackbarService.actionText$;
  }

  closeSnackbar(): void {
    this.snackbarService.close();
  }
}
